export { default as baseApi } from './base';
export { authApi } from './auth';
import { usersApi } from './users';
import { applicantsApi } from './applicants';
import { resourcesApi } from './resources';
import { rolesApi } from './roles';
import { lobsApi } from './lines-of-business';
import { newApplicantsApi } from './new-applicants';
import { videoQuestionProfilesApi } from './video-question-profiles';
import { qualificationQuestionProfilesApi } from './qualification-question-profiles';
import { typingTestsApi } from './typing-tests';
import { typingAssessmentTestResultsApi } from './typing-assessment-test-results';
import { talentDiscoveryApi } from './talent-discovery';
import { referralsApi } from './referrals';
import { promptsApi } from './prompts';
import { requisitionsApi } from './requisitions';
import { videoQuestionsApi } from './video-questions';
import { videoQuestionTestResultsApi } from './video-question-test-results';
import { resumeProfilesApi } from './resume-profiles';
import { resumeProfileTestResultsApi } from './resume-profile-test-results';
import { qualificationQuestionsApi } from './qualification-questions';

export default [
  usersApi,
  applicantsApi,
  resourcesApi,
  rolesApi,
  lobsApi,
  newApplicantsApi,
  videoQuestionProfilesApi,
  qualificationQuestionProfilesApi,
  typingTestsApi,
  typingAssessmentTestResultsApi,
  talentDiscoveryApi,
  referralsApi,
  promptsApi,
  requisitionsApi,
  videoQuestionsApi,
  videoQuestionTestResultsApi,
  resumeProfilesApi,
  resumeProfileTestResultsApi,
  qualificationQuestionsApi
];
